export default {
  WIKI: 'wiki',
  API_DOCS: 'api-docs',
  STATIC_SIDE_MENU: 'static_menu',
};
